<template>
    <swiper :slides-per-view="'auto'" :space-between="10">
        <swiper-slide v-for="item in productsList" :key="item.id" class="product__slide">
            <div class="product__card">
                <a :href="item.url" class="product__card_top">
                    <div class="image-container" v-if="item.cover" v-html="item.cover"></div>
                    <div class="image-container" v-else>
                        <img :src="item.defaultSrc" alt="img" class="image">
                    </div>
                    <div class="product_sku" v-if="item.sku">{{ $s('STR_SKU') + ' ' + item.sku }}</div>
                </a>
                <div class="product__title_block">
                    <a :href="item.url" class="product__card_title">
                        {{item.title}}
                    </a>
                </div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
import ajaxRequest from "../utils/ajaxRequest.js";
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import SwiperCore from 'swiper';

export default {
	components: {
		Swiper,
		SwiperSlide
	},
	props: {
		onMain: Boolean,
		onCatalog: Boolean,
        categoryId: {
            type: [Number],
            default: null
        },
        projectId: {
            type: [Number],
            default: null
        },
	},
	data() {
		return {
			loading: false,
			productsList: []
		};
	},
	methods: {
		async getData() {
			const postData = Object.assign({
				data: Object.assign({
					in_main: this.onMain ? 1 : 0,
					in_catalog: this.onCatalog ? 1 : 0,
                    category_id: this.categoryId ? this.categoryId : null,
                    project_id: this.projectId ? this.projectId : null
				}, this.queryParams)
			}, window.Application.config);

			this.loading = true;
			const response = await ajaxRequest("/__ajax/content/list_products", postData);
			this.loading = false;

			if (response.code == 0) {
				this.productsList = response.msgData.products;
			}
		}
	},
	mounted() {
		this.getData();
	}
}
</script>
